import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequestWithParams } from "../../services/API";
import { isEmpty } from "../../services/validation";
import { strings } from "../../utils/constants/strings";

export const adminCustomerPaymentsExportAction = createAsyncThunk(
  "adminCustomerPaymentsExportAction",
  async (requestInfo, { rejectWithValue }) => {
    let requestUrl = "?";

    try {
      if (!isEmpty(requestInfo.searchText)) {
        requestUrl += "&search_key=" + requestInfo.searchText;
      }

      if (requestInfo?.isFilter === strings.words.EXPIRED) {
        requestUrl += "&isExpired=true";
      } else if (requestInfo?.isFilter === strings.words.ACTIVE) {
        requestUrl += "&isExpired=false";
      }

      const result = await getRequestWithParams(
        requestInfo.language,
        "adminCustomerPaymentsExport",
        requestUrl,
        true
      );

      return result;
    } catch (error) {
      try {
        return rejectWithValue(JSON.parse(error.message));
      } catch (parseError) {
        return rejectWithValue({ message: error.message || "Export failed" });
      }
    }
  }
);
